import { type Localisation } from "./en";

export const french: Localisation = {
  dateFormats: {
    currentDateFormat: "eee, do LLLL",
    currentTimeFormat: "HH:mm",
    dateDayMonth: "eeee do LLLL",
    hoursMinutes: "HH:mm",
    dateDay: "eeee do",
  },
  StatusProvider: {
    "Screen is active but no token is present":
      "L'écran est actif mais aucun jeton n'est présent",
    "Network error": "Erreur réseau",
    "Checking display status": "Vérification de l'état de l'affichage",
    "Failed to get display status":
      "Échec de l'obtention de l'état de l'affichage",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "If this issue persists, please contact your Teamworks administrator.":
      "Si ce problème persiste, veuillez contacter votre administrateur Teamworks.",
    "This is usually due to a network error while setting up your device. Please reset your device using the button below and try again.":
      "Cela est généralement dû à une erreur de réseau lors de la configuration de votre appareil. Veuillez réinitialiser votre appareil en utilisant le bouton ci-dessous et réessayez.",
    "Setup failed to complete": "La configuration n'a pas pu être complétée",
    "Please reset your device using the button below and try again.":
      "Veuillez réinitialiser votre appareil en utilisant le bouton ci-dessous et réessayez.",
  },
  ConfigProvider: {
    "Loading configuration": "Chargement de la configuration",
  },
  AppProvider: {
    Loading: "Chargement",
    "No configuration selected": "Aucune configuration sélectionnée",
    "We could not find a configuration for the given code. Please contact your Teamworks administrator.":
      "Nous n'avons pas pu trouver de configuration pour le code fourni. Veuillez contacter votre administrateur Teamworks.",
    "This device has been registered, but no configuration has been set yet. Dont worry, you can easily update this device in the digital displays management app.":
      "Cet appareil a été enregistré, mais aucune configuration n'a encore été définie. Ne vous inquiétez pas, vous pouvez facilement mettre à jour cet appareil dans l'application de gestion des affichages numériques.",
    "Network error: failed to load playlist":
      "Erreur réseau: impossible de charger la playlist",
    "Device ID: {{deviceId}}": "Device ID: {{deviceId}}",
    "Resetting, please wait...":
      "Réinitialisation en cours, veuillez patienter...",
  },
  UpdatesProvider: {
    "Checking for update": "Vérification des mises à jour",
    "Downloading update": "Téléchargement de la mise à jour",
  },
  InteractionScreen: {
    "Loading...": "Chargement...",
    "Press any key to begin": "Appuyez sur une touche pour commencer",
    "No configurations assigned": "Aucune configuration assignée",
    "You can assign a configuration or a playlist to run on this device in the Digital Displays management app.":
      "Vous pouvez assigner une configuration ou une liste de lecture à exécuter sur cet appareil via l'application de gestion des affichages numériques.",
  },
  SetupScreen: {
    "Scan the QR code on your camera app":
      "Scannez le code QR avec votre application appareil photo",
  },
  TemplateScreen: {
    "Events page {{count}} of {{total}}":
      "Page des événements {{count}} sur {{total}}",
    Today: "Aujourd'hui",
    "All day": "Toute la journée",
    Tomorrow: "Demain",
  },
  ErrorScreen: {
    "Something went wrong": "Quelque chose s'est mal passé",
    "Sorry for the inconvience, our engineers have been notified and will be working on a fix":
      "Désolé pour le désagrément, nos ingénieurs ont été informés et travailleront sur une solution",
    "If this issue persists, please contact your account manager":
      "Si le problème persiste, veuillez contacter votre gestionnaire de compte",
    "Reset device": "Réinitialiser l'appareil",
    "Your IP address may need to be permitted: {{ip}}":
      "Votre adresse IP peut avoir besoin d'être autorisée : {{ip}}",
    "The app will attempt to automatically reset in {{seconds}} seconds":
      "L'application tentera de se réinitialiser automatiquement dans {{seconds}} secondes",
  },
  NextMatch: {
    days: "jours",
    hours: "heures",
    minutes: "minutes",
    seconds: "secondes",
  },
  MediaContentCarosel: {
    "Media not found": "Médias non trouvés",
  },
  PlaylistProvider: {
    "Loading...": "Chargement...",
    "Loading playlist": "Chargement de la playlist",
  },
  ScreenFooter: {
    Hardcoded: "Codé en dur",
  },
  NotFoundLayout: {
    "Configuration not found": "Configuration non trouvée",
  },
  StrengthWorkoutBoard: {
    "No Workout Selected": "Aucun entraînement sélectionné",
    "Select a workout from the Digital Display tab in S&C to display it here":
      "Sélectionnez un entraînement dans l'onglet Digital Display de S&C pour l'afficher ici",
  },
  WeatherWidget: {
    "Weather unavailable": "Météo indisponible",
  },
  NutritionMenu: {
    "Failed to fetch menu": "Échec du chargement du menu",
  },
  NutritionDiningStation: {
    "Failed to fetch dining station":
      "Échec du chargement de la station de restauration",
    "Add ons will affect nutrition information":
      "Les compléments affecteront les informations nutritionnelles",
  },
  Weather: {
    Today: "Today",
    "No weather data to show, please contact your Teamworks administrator.":
      "Aucune donnée météo à afficher, veuillez contacter votre administrateur Teamworks.",
    Clear: "Clair",
    Clouds: "Nuageux",
    Rain: "Pluie",
    Drizzle: "Bruine",
    Thunderstorm: "Orage",
    Snow: "Neige",
    Mist: "Brume",
    Smoke: "Fumée",
    Haze: "Brume sèche",
    Dust: "Poussière",
    Fog: "Brouillard",
    Sand: "Sable",
    Ash: "Cendre volcanique",
    Squall: "Bourrasque",
    Tornado: "Tornade",
  },
};
